import React, { useContext, useEffect, useRef, useState } from "react";
import { Sorting } from "../../../../components/Lists/Sorting";
import { Tooltip } from "@mui/material";
import "./QuoteList.css";
import { Tag } from "../../../../components/Tags/Tag";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import { Expandable } from "../../../../components/Expandable/Expandable";
import { DropdownsProvider } from "../../../../contexts/DropdownsContext";
import { QuotePrnList } from "./QuotePrnList";
import { DialogContext } from "../../../../contexts/DialogContext";
import { TableComponent } from "../../../../components/Table/TableComponent";
import { QuoteOrderContext } from "../../context/QuoteOrderContext";
import Skeleton from "react-loading-skeleton";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import { QuoteVendorModalWrapper } from "./QuoteModal/QuoteVendorModal";
import { GenericPartRequestModal } from "../../../StoresModule/Components/PartRequest/PartRequestModals/GenericPartRequestModal";
import { LABELS } from "../../../../globals/globals";
import { SortingProvider } from "../../../../contexts/SortingContext";
import { SortingHeader } from "../../../../components/Sorting/SortingHeader";
import { SortingButton } from "../../../../components/Sorting/SortingButton";
const ribbonColors = ["var(--blue-300)", "var(--green-350)", "#f7931e"];
const defaultColor = "var(--blue-300)";
const ribbon = [{ when: true, label: LABELS.DRAFT }];
// const dataList = [
//   {
//     id: 1,
//     requestedBy: "John Smith (john@company.com)",
//     company: "Spirit Airlines, Inc.",
//     dateSent: "June 5, 2025",
//     totalVendors: 4,
//     quoteExpiration: "June 15, 2025",
//     status: "Partially Quoted",
//   },
//   {
//     id: 2,
//     requestedBy: "John Smith (john@company.com)",
//     company: "Spirit Airlines, Inc.",
//     dateSent: "June 5, 2025",
//     totalVendors: 4,
//     quoteExpiration: "June 15, 2025",
//     status: "Pending",
//   },
//   {
//     id: 3,
//     codRFQ: "782310",
//     requestedBy: "Jane Doe (jane@company.com)",
//     company: "Delta Airlines",
//     dateSent: "June 3, 2025",
//     totalVendors: 5,
//     quoteExpiration: "June 14, 2025",
//     status: "Quoted",
//   },
//   {
//     id: 4,
//     codRFQ: "193024",
//     requestedBy: "Carlos Pérez (carlos@company.com)",
//     company: "United Airlines",
//     dateSent: "June 4, 2025",
//     totalVendors: 3,
//     quoteExpiration: "June 12, 2025",
//     status: "Expired",
//   },
//   {
//     id: 5,
//     codRFQ: "982341",
//     requestedBy: "Emily Clark (emily@company.com)",
//     company: "American Airlines",
//     dateSent: "June 2, 2025",
//     totalVendors: 6,
//     quoteExpiration: "June 13, 2025",
//     status: "Pending",
//   },
// ];
const tagsMapper = {
  success: "Quoted",
  info: "Partially Quoted",
  warning: "Pending",
  issued: "Expired",
};
const PartImage = ({ item }) => {
  const changeValue = (item, key, event) => {};

  return (
    <div className="image-container-checkbox">
      <Checkbox
        outlined
        checked={item.toOrder}
        onChange={(e) => changeValue(item, "toEdit", e)}
      />
    </div>
  );
};

const metadata = [
  {
    referencedColumnName: "part_number",
    label: "PN",
    specificWidth: "60px",
  },
  {
    referencedColumnName: "serial_number",
    label: "SN",
    specificWidth: "200px",
  },
  {
    referencedColumnName: "company_name",
    label: "Company",
    specificWidth: "100px",
  },
  {
    referencedColumnName: "batch_name",
    label: "Batch",
    specificWidth: "100px",
  },
  {
    referencedColumnName: "quantity",
    label: "QTY",
    specificWidth: "100px",
  },
  {
    referencedColumnName: "location_code",
    label: "Location",
    specificWidth: "100px",
  },
  {
    referencedColumnName: "part_description",
    label: "PN Description",
    specificWidth: "100px",
  },
  {
    referencedColumnName: "status",
    label: "Status",
    specificWidth: "100px",
  },
];

const data = [
  {
    id: "3517",
    part_id: 351,
    location_id: 26,
    aircraft_id: null,
    site_id: 1,
    rack_id: 64,
    shelf_id: 100,
    bin_id: null,
    quantity: 0.0,
    cost: -6000.0,
    transaction_count: 2,
    part_number: "JP-8",
    part_description:
      "kerosene-based aviation fuel used in commercial and military aircraft",
    serialized_part: null,
    uom_name: "Gallons",
    uom_abrevation: "GAL",
    uom_id: 16,
    company_id: 7,
    internal_batch: 7,
    batch_name: 7,
    location_code: "JFK",
    location_name: "Miami Intl WH 45, Rack 1 (Aisle Aisle 15), SHELF 2",
    aircraft_name: null,
    serial_number: null,
    last_transaction_date: "2025-07-22T15:35:44.463+00:00",
    last_transaction_quantity: 60.0,
    last_transaction_id: 10,
    last_transaction_unit_cost: 100.0,
    issued_transactions: 1,
    last_transaction_type: "Issued",
    company_name: "Spirit Airlines, Inc.",
    category_id: 3,
    sub_category_id: 21,
    ata_chapter_id: null,
    ata_section_id: null,
    ata_paragraph_id: null,
    status: "Available",
  },
  {
    id: "3518",
    part_id: 351,
    location_id: 26,
    aircraft_id: null,
    site_id: 1,
    rack_id: 64,
    shelf_id: 100,
    bin_id: null,
    quantity: 0.0,
    cost: -5000.0,
    transaction_count: 2,
    part_number: "JP-8",
    part_description:
      "kerosene-based aviation fuel used in commercial and military aircraft",
    serialized_part: null,
    uom_name: "Gallons",
    uom_abrevation: "GAL",
    uom_id: 16,
    company_id: 7,
    internal_batch: 8,
    batch_name: 8,
    location_code: "JFK",
    location_name: "Miami Intl WH 45, Rack 1 (Aisle Aisle 15), SHELF 2",
    aircraft_name: null,
    serial_number: null,
    last_transaction_date: "2025-07-22T20:10:36.353+00:00",
    last_transaction_quantity: 50.0,
    last_transaction_id: 13,
    last_transaction_unit_cost: 100.0,
    issued_transactions: 1,
    last_transaction_type: "Issued",
    company_name: "Spirit Airlines, Inc.",
    category_id: 3,
    sub_category_id: 21,
    ata_chapter_id: null,
    ata_section_id: null,
    ata_paragraph_id: null,
    status: "Available",
  },
  {
    id: "3519",
    part_id: 351,
    location_id: 26,
    aircraft_id: null,
    site_id: 1,
    rack_id: 64,
    shelf_id: 100,
    bin_id: null,
    quantity: 19.0,
    cost: -3100.0,
    transaction_count: 3,
    part_number: "JP-8",
    part_description:
      "kerosene-based aviation fuel used in commercial and military aircraft",
    serialized_part: null,
    uom_name: "Gallons",
    uom_abrevation: "GAL",
    uom_id: 16,
    company_id: 7,
    internal_batch: 9,
    batch_name: 9,
    location_code: "JFK",
    location_name: "Miami Intl WH 45, Rack 1 (Aisle Aisle 15), SHELF 2",
    aircraft_name: null,
    serial_number: null,
    last_transaction_date: "2025-07-23T14:07:39.953+00:00",
    last_transaction_quantity: 1.0,
    last_transaction_id: 21,
    last_transaction_unit_cost: 100.0,
    issued_transactions: 2,
    last_transaction_type: "Issued",
    company_name: "Spirit Airlines, Inc.",
    category_id: 3,
    sub_category_id: 21,
    ata_chapter_id: null,
    ata_section_id: null,
    ata_paragraph_id: null,
    status: "Available",
  },
  {
    id: "35112",
    part_id: 351,
    location_id: 26,
    aircraft_id: null,
    site_id: 1,
    rack_id: 64,
    shelf_id: 100,
    bin_id: null,
    quantity: 10.0,
    cost: 0.0,
    transaction_count: 1,
    part_number: "JP-8",
    part_description:
      "kerosene-based aviation fuel used in commercial and military aircraft",
    serialized_part: null,
    uom_name: "Gallons",
    uom_abrevation: "GAL",
    uom_id: 16,
    company_id: 7,
    internal_batch: 12,
    batch_name: 12,
    location_code: "JFK",
    location_name: "Miami Intl WH 45, Rack 1 (Aisle Aisle 15), SHELF 2",
    aircraft_name: null,
    serial_number: null,
    last_transaction_date: "2025-07-23T22:04:14.277+00:00",
    last_transaction_quantity: 10.0,
    last_transaction_id: 23,
    last_transaction_unit_cost: 0.0,
    issued_transactions: null,
    last_transaction_type: "Received",
    company_name: "Spirit Airlines, Inc.",
    category_id: 3,
    sub_category_id: 21,
    ata_chapter_id: null,
    ata_section_id: null,
    ata_paragraph_id: null,
    status: "Issued",
  },
  {
    id: "3512",
    part_id: 351,
    location_id: 26,
    aircraft_id: null,
    site_id: 1,
    rack_id: 64,
    shelf_id: 100,
    bin_id: 62,
    quantity: 0.0,
    cost: -5000.0,
    transaction_count: 2,
    part_number: "JP-8",
    part_description:
      "kerosene-based aviation fuel used in commercial and military aircraft",
    serialized_part: null,
    uom_name: "Gallons",
    uom_abrevation: "GAL",
    uom_id: 16,
    company_id: 7,
    internal_batch: 2,
    batch_name: 2,
    location_code: "JFK",
    location_name: "Miami Intl WH 45, Rack 1 (Aisle Aisle 15), SHELF 2, BIN 1",
    aircraft_name: null,
    serial_number: null,
    last_transaction_date: "2025-07-18T21:52:05.937+00:00",
    last_transaction_quantity: 50.0,
    last_transaction_id: 3,
    last_transaction_unit_cost: 100.0,
    issued_transactions: 1,
    last_transaction_type: "Issued",
    company_name: "Spirit Airlines, Inc.",
    category_id: 3,
    sub_category_id: 21,
    ata_chapter_id: null,
    ata_section_id: null,
    ata_paragraph_id: null,
    status: "Issued",
  },
  {
    id: "35110",
    part_id: 351,
    location_id: 26,
    aircraft_id: null,
    site_id: 1,
    rack_id: 64,
    shelf_id: 100,
    bin_id: 62,
    quantity: 45.0,
    cost: 0.0,
    transaction_count: 1,
    part_number: "JP-8",
    part_description:
      "kerosene-based aviation fuel used in commercial and military aircraft",
    serialized_part: null,
    uom_name: "Gallons",
    uom_abrevation: "GAL",
    uom_id: 16,
    company_id: 7,
    internal_batch: 10,
    batch_name: 10,
    location_code: "JFK",
    location_name: "Miami Intl WH 45, Rack 1 (Aisle Aisle 15), SHELF 2, BIN 1",
    aircraft_name: null,
    serial_number: null,
    last_transaction_date: "2025-07-23T13:58:36.530+00:00",
    last_transaction_quantity: 45.0,
    last_transaction_id: 20,
    last_transaction_unit_cost: 0.0,
    issued_transactions: null,
    last_transaction_type: "Received",
    company_name: "Spirit Airlines, Inc.",
    category_id: 3,
    sub_category_id: 21,
    ata_chapter_id: null,
    ata_section_id: null,
    ata_paragraph_id: null,
    status: "Issued",
  },
  {
    id: "13",
    part_id: 1,
    location_id: 26,
    aircraft_id: null,
    site_id: 1,
    rack_id: 64,
    shelf_id: 100,
    bin_id: null,
    quantity: 0.0,
    cost: 0.0,
    transaction_count: 2,
    part_number: "ZABCDEFGH",
    part_description: "Main landing gear for aircraft.",
    serialized_part: 28,
    uom_name: "Each",
    uom_abrevation: "EA",
    uom_id: 18,
    company_id: 7,
    internal_batch: 3,
    batch_name: 3,
    location_code: "JFK",
    location_name: "Miami Intl WH 45, Rack 1 (Aisle Aisle 15), SHELF 2",
    aircraft_name: null,
    serial_number: "SN-97NN",
    last_transaction_date: "2025-07-22T21:02:30.830+00:00",
    last_transaction_quantity: 1.0,
    last_transaction_id: 15,
    last_transaction_unit_cost: 100.0,
    issued_transactions: 1,
    last_transaction_type: "Issued",
    company_name: "Spirit Airlines, Inc.",
    category_id: 2,
    sub_category_id: 6,
    ata_chapter_id: 8,
    ata_section_id: 3,
    ata_paragraph_id: 4,
    status: "Issued",
  },
  {
    id: "14",
    part_id: 1,
    location_id: 26,
    aircraft_id: null,
    site_id: 1,
    rack_id: 64,
    shelf_id: 100,
    bin_id: null,
    quantity: 0.0,
    cost: -100.0,
    transaction_count: 2,
    part_number: "ZABCDEFGH",
    part_description: "Main landing gear for aircraft.",
    serialized_part: 29,
    uom_name: "Each",
    uom_abrevation: "EA",
    uom_id: 18,
    company_id: 7,
    internal_batch: 4,
    batch_name: 4,
    location_code: "JFK",
    location_name: "Miami Intl WH 45, Rack 1 (Aisle Aisle 15), SHELF 2",
    aircraft_name: null,
    serial_number: "SN-99NN",
    last_transaction_date: "2025-07-22T21:10:15.703+00:00",
    last_transaction_quantity: 1.0,
    last_transaction_id: 16,
    last_transaction_unit_cost: 100.0,
    issued_transactions: 1,
    last_transaction_type: "Issued",
    company_name: "Spirit Airlines, Inc.",
    category_id: 2,
    sub_category_id: 6,
    ata_chapter_id: 8,
    ata_section_id: 3,
    ata_paragraph_id: 4,
    status: "Issued",
  },
  {
    id: "15",
    part_id: 1,
    location_id: 26,
    aircraft_id: null,
    site_id: 1,
    rack_id: 64,
    shelf_id: 100,
    bin_id: null,
    quantity: 0.0,
    cost: -100.0,
    transaction_count: 2,
    part_number: "ZABCDEFGH",
    part_description: "Main landing gear for aircraft.",
    serialized_part: 30,
    uom_name: "Each",
    uom_abrevation: "EA",
    uom_id: 18,
    company_id: 7,
    internal_batch: 5,
    batch_name: 5,
    location_code: "JFK",
    location_name: "Miami Intl WH 45, Rack 1 (Aisle Aisle 15), SHELF 2",
    aircraft_name: null,
    serial_number: "SN-01",
    last_transaction_date: "2025-07-22T21:43:40.897+00:00",
    last_transaction_quantity: 1.0,
    last_transaction_id: 18,
    last_transaction_unit_cost: 100.0,
    issued_transactions: 1,
    last_transaction_type: "Issued",
    company_name: "Spirit Airlines, Inc.",
    category_id: 2,
    sub_category_id: 6,
    ata_chapter_id: 8,
    ata_section_id: 3,
    ata_paragraph_id: 4,
    status: "Available",
  },
  {
    id: "16",
    part_id: 1,
    location_id: 26,
    aircraft_id: null,
    site_id: 1,
    rack_id: 64,
    shelf_id: 100,
    bin_id: null,
    quantity: 0.0,
    cost: -100.0,
    transaction_count: 2,
    part_number: "ZABCDEFGH",
    part_description: "Main landing gear for aircraft.",
    serialized_part: 31,
    uom_name: "Each",
    uom_abrevation: "EA",
    uom_id: 18,
    company_id: 7,
    internal_batch: 6,
    batch_name: 6,
    location_code: "JFK",
    location_name: "Miami Intl WH 45, Rack 1 (Aisle Aisle 15), SHELF 2",
    aircraft_name: null,
    serial_number: "SN-002",
    last_transaction_date: "2025-07-22T21:43:53.153+00:00",
    last_transaction_quantity: 1.0,
    last_transaction_id: 19,
    last_transaction_unit_cost: 100.0,
    issued_transactions: 1,
    last_transaction_type: "Issued",
    company_name: "Spirit Airlines, Inc.",
    category_id: 2,
    sub_category_id: 6,
    ata_chapter_id: 8,
    ata_section_id: 3,
    ata_paragraph_id: 4,
    status: "Available",
  },
];

export const QuoteList = () => {
  //Tooltips
  const {
    quoteList,
    loadingQuotes,
    quoteToOrderList,
    setQuoteToOrderList,
    hasDetailOnDraft,
    setUpdateInfoList,
    setSortingOrder,
  } = useContext(QuoteOrderContext);
  const { openDialog, closeDialog } = useContext(DialogContext);
  const [openStates, setOpenStates] = useState({});
  const switchedTagsMapper = Object.fromEntries(
    Object.entries(tagsMapper).map(([key, value]) => [value, key])
  );

  const propertyRefs = useRef({});
  const [tooltips, setTooltips] = useState({});
  const listRef = useRef(null);

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      // if (!setLoadingPartsReq) requestNextPage();
    }
  };

  const toggleOpenState = (aircraftId, open, item) => {
    const hasSelectedParts = quoteToOrderList?.length > 0;
    const isDifferentRequest =
      hasSelectedParts && item.id !== quoteToOrderList[0].quote_request_id;

    if (isDifferentRequest) {
      openDialog({
        component: GenericPartRequestModal,
        props: {
          title: "Warning",
          description: `You have parts selected in the current (<strong>RFQ-${quoteToOrderList[0].quote_request_id}</strong>).<br/>Open a new one anyway? This will cancel your current selection.`,
          close: closeDialog,
          okAction: () => openAndCloseItemFromDialog(aircraftId),
        },
      });
    } else {
      closeAllOpenStates();
      setTimeout(() => {
        setOpenStates((prevState) => ({
          ...prevState,
          [aircraftId]: open,
        }));
      }, 100);
    }
  };
  const openAndCloseItemFromDialog = (partRequestId) => {
    setQuoteToOrderList([]);
    closeDialog();
    closeAllOpenStates();
    setTimeout(() => {
      setOpenStates((prevState) => ({
        ...prevState,
        [partRequestId]: !openStates[partRequestId],
      }));
    }, 100);
  };
  const closeAllOpenStates = () => {
    setOpenStates((prevState) => {
      const newState = {};
      Object.keys(prevState).forEach((key) => {
        newState[key] = false;
      });
      return newState;
    });
  };
  useEffect(() => {
    const newTooltips = {};
    Object.entries(propertyRefs.current).forEach(([key, el]) => {
      if (el) {
        newTooltips[key] = el.scrollWidth > el.clientWidth;
      }
    });
    setTooltips(newTooltips);
  }, []);

  const openVendorModal = (item) => {
    openDialog({
      component: QuoteVendorModalWrapper,
      props: {
         quote: item,
        close: closeDialog,
        setUpdateInfoList,
      },
    });
  };

  const handleQuoteUpdate = () => {
    setUpdateInfoList(new Date().getTime());
  };

  return (
    <>
      <div className="sorting-header">
        <div className="sorting-free-slot"> </div>

        <SortingHeader showHeaderOrder={true} />

        {/* <Sorting
          onOrderChange={getSortingOrder}
          ignoreProperties={true}
          displayButton={false}
          initialSort="date_request_required"
          showHeaderOrder={true}
          properties={{
            id: "Cod RFQ",
            part_number: "Requested By",
            required: "Company",
            issued: "Date Sent",
            remaining: "Total Vendors",
            pendingOrder: "Status",
          }}
        ></Sorting> */}
      </div>
      <div className="quote-list" ref={listRef} onScroll={handleScroll}>
        {loadingQuotes ? (
          Array.from({ length: 7 }).map((_, idx) => (
            <div key={idx} className="item-container-skeleton">
              <Skeleton
                style={{ borderRadius: "10px" }}
                height="1.68rem"
                width={40}
              />
              <div className="item-skeleton-content">
                <Skeleton height={20} width="80%" />
              </div>
              <Skeleton height={30} width="7rem" />
            </div>
          ))
        ) : quoteList.length === 0 ? (
          <ResultsNotFound />
        ) : (
          quoteList.map((item, idx) => (
            <Expandable
              key={`${item?.id}-${idx}`}
              name={`${item?.id}-type-configuration-${idx}`}
              summary={
                <React.Fragment key={`${item.id}-${idx}`}>
                  <div
                    className={`item-quote-management-container ${
                      openStates[item?.id] ? "active" : ""
                    } ${item?.hasVendorSelected ? "selected" : ""}`}
                  >
                    {ribbon && hasDetailOnDraft(item.id, null, true) && (
                      <div className="ribbons-container">
                        {ribbon
                          .filter?.((r) => r.when)
                          ?.map?.((r, i, a) => (
                            <span
                              className="ribbon"
                              key={r.label}
                              style={{
                                backgroundColor:
                                  r.color ??
                                  ribbonColors[i % ribbonColors.length] ??
                                  defaultColor,
                                left:
                                  i < a.length - 1
                                    ? `${-0.5 * (ribbon.length - 1 - i)}rem`
                                    : "",
                              }}
                            >
                              {r.label}
                            </span>
                          ))}
                      </div>
                    )}
                    {/* <PartImage item={item} /> */}
                    {["id", "email", "name", "date_sent", "total_vendor"].map(
                      (label) => (
                        <div
                          className={`property ${
                            label === "total_vendor" ||
                            label === "quoteExpiration"
                              ? "centerItem"
                              : ""
                          }`}
                          key={label}
                        >
                          <Tooltip
                            title={
                              tooltips[`${item.id}-${label}`] ? item[label] : ""
                            }
                            arrow
                          >
                            {label == "id" ? (
                              <p
                                className="bold-font"
                                ref={(el) => {
                                  if (el) {
                                    propertyRefs.current[
                                      `${item.id}-${label}`
                                    ] = el;
                                  }
                                }}
                              >
                                {item[label]}
                              </p>
                            ) : label == "total_vendor" ? (
                              <p
                                className="tag-vendor-font"
                                ref={(el) => {
                                  if (el) {
                                    propertyRefs.current[
                                      `${item.id}-${label}`
                                    ] = el;
                                  }
                                }}
                              >
                                {item[label]}
                              </p>
                            ) : (
                              <p
                                className="light-font"
                                ref={(el) => {
                                  if (el) {
                                    propertyRefs.current[
                                      `${item.id}-${label}`
                                    ] = el;
                                  }
                                }}
                              >
                                {item[label]}
                              </p>
                            )}
                          </Tooltip>
                        </div>
                      )
                    )}
                    <Tag
                      style={{ width: "9vw" }}
                      tag={item.status}
                      type={switchedTagsMapper[item.status]}
                    ></Tag>
                    <button
                      className={`filled iconTextButton ${
                        item.status === "Ordered" ? "disabled" : ""
                      }`}
                      onClick={(e) => openVendorModal(item)}
                    >
                      <i className="icon-terms-condition"></i>
                      <span>Enter Quote Manually</span>
                    </button>
                  </div>
                </React.Fragment>
              }
              isOpen={openStates[item?.id]}
              onToggle={(open, e) => toggleOpenState(item?.id, open, item)}
            >
              {openStates[item?.id] && (
                <DropdownsProvider>
                  <QuotePrnList quote={item}></QuotePrnList>
                </DropdownsProvider>
              )}
            </Expandable>
          ))
        )}
      </div>
    </>
  );
};
